import { Component, Input } from "@angular/core";
import { SharedService } from "src/app/services/shared.service";

@Component({
  selector: "app-full-loader-with-msg",
  templateUrl: "./full-loader-with-msg.component.html",
  styleUrls: ["./full-loader-with-msg.component.scss"],
})
export class FullLoaderWithMsgComponent {
  msg: string = "";
  isEnabled: boolean = false;
  fireCloseAnimation: boolean = false;
  startImediate: boolean = false;
  @Input() pageType: string = "Fahes"; // default, login, register, forgot-password
  constructor(private sharedService: SharedService) {
    this.enableListener();
    // setTimeout(() => {
    //   this.enableLoader();
    // }, 2000);

    // setTimeout(() => {
    //   this.disableLoader();
    // }, 5000);
  }

  enableLoader(startImediate: boolean) {
    if (typeof window !== "undefined") {
      this.startImediate = startImediate;
      this.isEnabled = true;
      document.body.style.overflow = `hidden`;
    }
  }

  disableLoader() {
    if (typeof window !== "undefined") {
      this.fireCloseAnimation = true;
      setTimeout(() => {
      this.isEnabled = false;
      this.fireCloseAnimation = false;
      document.body.style.overflow = `scroll`;
      }, 300);
    }
  }

  enableListener() {
    let _this = this;
    let firstFire: boolean = true; //to ignore first time, the reason behind that is the initialization of the variable will cause this
    this.sharedService.loaderFlagWithMsg$.subscribe((flag: any) => {
      this.msg = flag.msg;
      if (!firstFire) {
        const globalFlag = !!flag.value;
        globalFlag
          ? _this.enableLoader(flag.startImediate)
          : _this.disableLoader();
      } else {
        firstFire = false;
      }
    });
  }
}
